<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
body{
  position: fixed;
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
</style>
